import clsx from 'clsx';
import type { CSSProperties } from 'react';
import styles from './Skeleton.module.css';

/** Shimmering placeholder. Size it with width/height/radius so loading causes no layout shift. */
export function Skeleton({
  width = '100%',
  height = 16,
  radius = 10,
  className,
}: {
  width?: CSSProperties['width'];
  height?: CSSProperties['height'];
  radius?: number;
  className?: string;
}) {
  return (
    <span className={clsx(styles.sk, className)} style={{ width, height, borderRadius: radius }} aria-hidden="true" />
  );
}
